import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import ViewAllContent from '../components/pages/meeting-room/view-all/content';
import NotFoundPage from './NotFoundPage.js';

function MeetingRoomPage(props) {
  const dispatch = useDispatch();

  const redirectToPageNotFound = useSelector((state) => state.sharedReducer.redirectToPageNotFound);
  const hasMeetingRooms = useSelector((state) => state.usersReducer.userProfile.hasMeetingRooms);
  const meetingRooms = useSelector((state) => state.meetingRoomReducer.meetingRooms);
  const mrSearchForm = useSelector((state) => state.meetingRoomReducer.mrSearchForm);
  const updateSearchColumn = useSelector((state) => state.sharedReducer.updateSearchColumn);
  const meetingRoomForm = useSelector((state) => state.meetingRoomReducer.meetingRoomForm);
  const permissions = useSelector((state) => state.meetingRoomReducer.meetingRooms.permissions);
  const isInCall = useSelector((state) => state.usersReducer.isInCall);
  const showCopyLinkToClipboardModalInMR = useSelector((state) => state.modalReducer.showCopyLinkToClipboardModalInMR);
  const isUserInMeetingRoomCall = useSelector(
    (state) =>
      state.meetingRoomReducer.userCurrentMeetingRoomCall &&
      state.meetingRoomReducer.userCurrentMeetingRoomCall.isUserInCall
  );
  const currentMeetingRoomCall = useSelector((state) => state.meetingRoomReducer.userCurrentMeetingRoomCall);
  const totalMeetingRooms = useSelector((state) => state.meetingRoomReducer.totalMeetingRooms);
  const showViewMeetingRoomParticipantModal = useSelector(
    (state) => state.modalReducer.showViewMeetingRoomParticipantModal
  );
  const showEditMeetingRoomModal = useSelector((state) => state.modalReducer.showEditMeetingRoomModal);
  const userId = useSelector((state) => state.usersReducer.userProfile.id);
  const selectedParticipantForm = useSelector((state) => state.meetingRoomReducer.selectedParticipantForm);
  const showMeetingRoomResetGuestLink = useSelector((state) => state.modalReducer.showMeetingRoomResetGuestLink);
  const showDeleteMeetingRoomModal = useSelector((state) => state.modalReducer.showDeleteMeetingRoomModal);
  const selectedMeetingRoom = useSelector((state) => state.meetingRoomReducer.selectedMeetingRoom);

  const [divStyle, setDivStyle] = useState({ zoom: props.zoom || 1 });

  return redirectToPageNotFound || !hasMeetingRooms ? (
    <NotFoundPage dispatch={dispatch} />
  ) : (
    <div style={divStyle}>
      <ViewAllContent
        noRightMenu={props.noRightMenu}
        meetingRooms={meetingRooms}
        mrSearchForm={mrSearchForm}
        updateSearchColumn={updateSearchColumn}
        meetingRoomForm={meetingRoomForm}
        showCopyLinkToClipboardModalInMR={showCopyLinkToClipboardModalInMR}
        isInCall={isInCall || isUserInMeetingRoomCall}
        currentMeetingRoomCall={currentMeetingRoomCall}
        showViewMeetingRoomParticipantModal={showViewMeetingRoomParticipantModal}
        showEditMeetingRoomModal={showEditMeetingRoomModal}
        userId={userId}
        selectedParticipantForm={selectedParticipantForm}
        selectedMeetingRoom={selectedMeetingRoom}
        showMeetingRoomResetGuestLink={showMeetingRoomResetGuestLink}
        showDeleteMeetingRoomModal={showDeleteMeetingRoomModal}
        dispatch={dispatch}
      />
    </div>
  );
}

export default MeetingRoomPage;
